<template>
	<img :src="source" alt="Bell Oldow, Inc." class="logo" />
</template>
<script>

export default {
	props: {
		variant: {
			type: String,
			default: 'white'
		}
	},
	computed: {
		source () {
			if (this.variant === 'white') {
				return '/img/logo-white.png'
			}

			if (this.variant === 'filled') {
				return '/img/logo-filled.png'
			}

			return '/img/logo-white.png'
		}
	}
}
</script>
